export default [
    {
      mode:'history',
      name: 'add_car',
      path: '/add_car',
      component: () => import(/* webpackChunkName: "add_car" */ './AddCar')
    }
  ]